import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { LanguageService } from '../services/language.service';

export function validNumberValidator(
  languageService: LanguageService,
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (
      control.value === undefined ||
      control.value === null ||
      languageService.isCalculatable(control.value, true)
    ) {
      return null;
    }

    return { invalidNumber: true };
  };
}

@Directive({
  selector: '[appValidNumber]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidNumberValidatorDirective,
      multi: true,
    },
  ],
})
export class ValidNumberValidatorDirective {}
